import { TableCell } from "@mui/material";
import React from "react";
export default function GridCell(props) {
    const { cell, children, columnWidth, isRowLoading, style } = props;
    return (React.createElement(TableCell, { component: "div", ...cell.getCellProps({
            style: {
                ...style,
                paddingRight: "0.875rem",
                textAlign: cell.column?.align || "left",
                width: columnWidth ?? cell.column.pxWidth ?? cell.column.width,
                minWidth: cell.column.minWidth,
                maxWidth: cell.column.maxWidth,
                flex: "",
                ...(cell.column.flexGrow && { flexGrow: cell.column.flexGrow, flexShrink: 0 }),
                ...(!(cell.column.flexGrow || cell.column.pxWidth) && { flexGrow: 1, flexShrink: 0 }),
                opacity: isRowLoading ? "0.4" : style?.opacity
            }
        }) }, children));
}
